import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wageCompreBA" }
const _hoisted_2 = { class: "wageCompreBA" }
const _hoisted_3 = { class: "wageCompreBA" }

import WageCompareBefore from "../../../components/admin/wage/WageCompareBefore.vue";
import WageCompareAfter from "../../../components/admin/wage/WageCompareAfter.vue";
import WageReport from "../../../components/admin/wage/WageReport.vue";
import FormatMonth from "../../../components/admin/common/datePicker/FormatMonth.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'WageCompare',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createBlock(_component_v_sheet, { style: {"width":"3000px","max-width":"3000px !important"} }, {
    default: _withCtx(() => [
      _createVNode(_component_v_toolbar, { flat: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_toolbar_title, {
            class: "fontNotoSans700",
            style: {"max-width":"240px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 임금 서비스적용 비교분석 ")
            ]),
            _: 1
          }),
          _createElementVNode("h3", null, [
            _createVNode(FormatMonth)
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(WageCompareBefore)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(WageCompareAfter)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(WageReport)
      ])
    ]),
    _: 1
  }))
}
}

})